import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

const FormField = ({ id, label, type, value, onChange, placeholder, testId }) => (
  <div>
    <Label htmlFor={id}>{label}</Label>
    <Input
      id={id}
      type={type}
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      required
      data-testid={testId}
      className="mt-1"
    />
  </div>
);

const AdminLoginForm = ({ email, password, loading, onEmail, onPassword, onSubmit }) => (
  <form onSubmit={onSubmit}>
    <div className="space-y-4">
      <FormField
        id="email" label="Email" type="email"
        value={email} onChange={(e) => onEmail(e.target.value)}
        placeholder="you@organisation.com" testId="admin-email-input"
      />
      <FormField
        id="password" label="Password" type="password"
        value={password} onChange={(e) => onPassword(e.target.value)}
        placeholder="Enter your password" testId="admin-password-input"
      />
      <Button
        type="submit"
        disabled={loading}
        className="w-full bg-slate-900 text-white hover:bg-slate-800 mt-6"
        data-testid="admin-login-button"
      >
        {loading ? 'Logging in...' : 'Login'}
      </Button>
    </div>
  </form>
);

export default AdminLoginForm;
